<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4" >
            <v-card class="elevation-1">
                <!-- <v-toolbar
                color="primary"
                dark
                flat
                >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <v-btn
                        :href="source"
                        icon
                        large
                        target="_blank"
                        v-on="on"
                    >
                        <v-icon>mdi-code-tags</v-icon>
                    </v-btn>
                    </template>
                    <span>Source</span>
                </v-tooltip>
                </v-toolbar> -->
                <v-card-text>
                    <v-form @keydown.enter="login">
                        <v-text-field
                        label="Email"
                        name="email"
                        prepend-icon="mdi-account"
                        type="text"
                        :rules="emailRules"
                        v-model="email"
                        required
                        @keydown.enter="login"
                        ></v-text-field>

                        <v-text-field
                        id="password"
                        label="Password"
                        name="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        v-model="password"
                        required
                        @keydown.enter="login"
                        ></v-text-field>
                    </v-form>
                    <div align="center"><span class="red--text">{{msg}}</span></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="login">Login</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>


<script>
  export default {
    name: 'LoginBlock',
    data: () => ({
        username: '',
        email: '',
        password: '',
        msg: '',
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }),
    mounted() {
        console.log('Checking Login');
        this.$http
            .get(this.getHost() + 'admin/user')
            .then(response => {
                console.log(response);
                if (response.status == 200) {
                    console.log("Logged in = " + response.body['logged_in']);
                    if (response.body['logged_in']) {
                        this.username = response.body['username'];
                        this.$emit('onLogin', this.username);
                        this.msg = ''
                    } else {
                        this.msg = response.body['msg']
                    }
                }
            }, error => {
                console.log(error);
                this.msg = error.body['msg']
            });
    },
    methods: {
      login() {

        let formData = new FormData();
        formData.append('email', this.email);
        formData.append('password', this.password);
        this.password = '';  // so password is not save in the Vue Instance or DOM

        this.$http
            .post(this.getHost() + 'admin/login', formData)
            .then(response => {
                console.log(response);
                if (response.status == 200) {
                console.log("Logged in = " + response.body['logged_in']);
                    if (response.body['logged_in']) {
                        this.username = response.body['username'];
                        this.$emit('onLogin', this.username);
                        this.msg = ''
                    } else {
                        this.msg = response.body['msg']
                    }
                }
            }, error => {
                this.msg = error.body['msg']
            });
            
      },
      logout() {
        console.log("Logout new");

        this.$http
            .get(this.getHost() + 'admin/logout')
            .then(response => {
                console.log(response);
                if (response.status == 200) {
                console.log("Logged in = " + response.body['logged_in']);
                if (!response.body['logged_in']) {
                    this.username = '';
                    this.$emit('onLogout');
                }
                }
            }, error => {
                this.username = '';
                this.$emit('onLogout');
                this.msg = error.body['msg'];
            });
      },
    }
  }
</script>
